const REGION_ROUTE_PREFIX = '/[region]';

/**
 * Converts Next.js' internal regional page pathname to its public route template.
 * The hostname rewrite owns the region, so it must not affect client-side route checks.
 */
export const stripRegionPathPrefix = (pathname: string): string => {
  if (pathname === REGION_ROUTE_PREFIX) return '/';

  if (pathname.startsWith(`${REGION_ROUTE_PREFIX}/`)) {
    return pathname.slice(REGION_ROUTE_PREFIX.length);
  }

  return pathname;
};
